import React from 'react';
import { Stat } from 'app/components/standings/StandingsStyles';
import { Typography } from '@fupa/fupa-uikit';
import getFormStandingsLastResults from 'app/components/standings/FormStandings.helpers';
import styled from 'styled-components';
const LastFive = styled.div.withConfig({
  componentId: "sc-1yp5kqf-0"
})(["min-width:6.25rem;display:flex;justify-content:flex-end;"]);
const FormStandingStats = _ref => {
  let {
    lastResults,
    points
  } = _ref;
  const lastFive = getFormStandingsLastResults(lastResults);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(LastFive, {
    "data-sentry-element": "LastFive",
    "data-sentry-source-file": "FormStandingStats.tsx"
  }, lastFive), /*#__PURE__*/React.createElement(Stat, {
    align: "center",
    minWidth: 32,
    "data-sentry-element": "Stat",
    "data-sentry-source-file": "FormStandingStats.tsx"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    "data-sentry-element": "Typography",
    "data-sentry-source-file": "FormStandingStats.tsx"
  }, points)));
};
export default FormStandingStats;